import "zone.js/dist/zone";
import "./polyfills";
import "./main.scss";
import "./components/RelatedApps";
import { shell } from "./services/shell";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

window["shell"] = shell;
shell.start();

